import styled from "styled-components";
import StoreCard from "../cards/StoreCard";

const Meta = styled.p`
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  margin: 0 0 1rem;
`;

const ContentWrap = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
`;

const Empty = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 3rem;
  text-align: center;
`;

const ClearBtn = styled.button`
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: hsl(${({ theme }) => theme.colors.primary});
  text-decoration: underline;
`;

export default function StoresResultsBlock({
  filtered,
  searchQuery,
  filterLetter,
  onClearFilters,
}) {
  return (
    <ContentWrap>
      <Meta>
        {filtered.length} store{filtered.length !== 1 ? "s" : ""} found
        {filterLetter && <span> starting with &quot;{filterLetter}&quot;</span>}
        {searchQuery && <span> matching &quot;{searchQuery}&quot;</span>}
      </Meta>
      <Grid>
        {filtered.map((store) => (
          <StoreCard key={store.id} store={store} />
        ))}
      </Grid>
      {filtered.length === 0 && (
        <Empty>
          <p style={{ margin: 0, color: "hsl(220 10% 46%)" }}>
            No stores found matching your criteria.
          </p>
          <ClearBtn type="button" onClick={onClearFilters}>
            Clear all filters
          </ClearBtn>
        </Empty>
      )}
    </ContentWrap>
  );
}
